package net.bothosting.docs.pages.faqs_and_info

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initNodes_ip_and_informationPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("faqs_and_info/nodes_ip_and_information.md", FrontMatterElement.EmptyMap))
}

@Page("/faqs_and_info/nodes-ip-and-information")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Nodes_ip_and_informationPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("nodes-ip-information") }) {
        org.jetbrains.compose.web.dom.Text("Nodes IP & Information")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("This is for server nodes, not the development language!")
            }
            org.jetbrains.compose.web.dom.Text(" You can find the server node in your server control page, check the ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("Settings")
            }
            org.jetbrains.compose.web.dom.Text(" tab in your server control panel.")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("free-nodes") }) {
        org.jetbrains.compose.web.dom.Text("🆓 Free Nodes ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#mrt3ddlred0");attr("id", "mrt3ddlred0")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Those nodes are accessible to everyone, your servers will be deployed to one of those nodes unless you bought a coins pack which includes premium nodes access.")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("de1: ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("167.235.13.16")
            }
            org.jetbrains.compose.web.dom.Text(" ( Germany )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("de3: ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("157.90.181.183")
            }
            org.jetbrains.compose.web.dom.Text(" ( Germany )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi1: ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("95.216.39.179")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi2: ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("95.216.10.105")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi3: ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("65.108.103.151")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi4 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("65.21.202.154")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi5 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("65.108.3.108")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi6 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("65.108.77.37")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi7 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("37.27.65.125")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi8 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("95.217.151.27")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi9 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("95.216.12.48")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi10 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("37.27.169.207")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi11 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("65.108.39.249")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi12 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("95.217.140.174")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi13 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("95.217.148.96")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("fi14 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("157.180.7.55")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland )")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("premium-nodes") }) {
        org.jetbrains.compose.web.dom.Text("👑 Premium Nodes ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#w8ra3lxwtbx");attr("id", "w8ra3lxwtbx")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can get access to Premium nodes by buying a coins pack of ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("3${'$'} or higher")
        }
        org.jetbrains.compose.web.dom.Text(" using a payment method listed in the ")
        com.varabyte.kobweb.silk.components.navigation.Link("/faqs_and_info/payment-guide") {
            org.jetbrains.compose.web.dom.Text("payment-guide.md")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" The payment is ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("not")
            }
            org.jetbrains.compose.web.dom.Text(" monthly/yearly or similar, it’s enough to buy a pack once to have premium nodes lifetime.")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("Please note that only servers created after access to it will be deployed there. You can request your servers created before of access to them to be moved in a support ticket.")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("us1: ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("103.60.13.254")
            }
            org.jetbrains.compose.web.dom.Text(" ( United States - Premium Node )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("us2: ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("172.81.128.14")
            }
            org.jetbrains.compose.web.dom.Text(" ( United States - Premium Node )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("us3: ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("103.60.13.234")
            }
            org.jetbrains.compose.web.dom.Text(" ( United States - Premium Node )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("prem-eu1 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("37.27.141.177")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland - Premium Node )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("prem-eu2 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("65.21.16.214")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland - Premium Node )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("prem-eu3 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("37.27.162.36")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland - Premium Node )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("prem-eu4 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("37.27.140.228")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland - Premium Node )")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("prem-eu5 ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("157.180.7.37")
            }
            org.jetbrains.compose.web.dom.Text(" ( Finland - Premium Node )")
        }
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br")
}
